export function signInRequest(document, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { document, password },
  };
}

export function authDocument(document) {
  return {
    type: '@auth/AUTH_DOCUMENT_REQUEST',
    payload: { document },
  };
}
export function authDocumentSuccess(document) {
  return {
    type: '@auth/AUTH_DOCUMENT',
    payload: { document },
  };
}
export function signInSuccess(token, user) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user },
  };
}

export function signUpRequest(name, email, password) {
  return {
    type: '@auth/SIGN_UP_REQUEST',
    payload: { name, email, password },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  };
}

export function forgetPasswordRequest(document) {
  return {
    type: '@auth/FORGET_PASSWORD_REQUEST',
    payload: { document },
  };
}

export function forgetPasswordSuccess(document) {
  return {
    type: '@auth/FORGET_PASSWORD',
    payload: { document },
  };
}
